export const DREAM_USER_EMAIL = "dream@supervision.earth";
export const DREAM_SPECIAL_EVENT_ID = "dream_special_event";

export function isDreamUser(email?: string | null): boolean {
  return email === DREAM_USER_EMAIL;
}

export function getSviObjectEventId(objectId: string): string {
  if (objectId === "0001") {
    return DREAM_SPECIAL_EVENT_ID;
  }
  return `svi_object_event_${objectId}`;
}

export function parseSviObjectEventId(eventId: string): string | null {
  if (eventId === DREAM_SPECIAL_EVENT_ID) {
    return "0001";
  }
  const match = /^svi_object_event_(.+)$/.exec(eventId);
  return match ? match[1] : null;
}

export function isSviObjectMapEvent(eventId: string): boolean {
  return parseSviObjectEventId(eventId) != null;
}
